import isSafari from '@/helpers/isSafari';

/**
 * @module yandex-captcha/executeYandexCaptchaInvisible
 * @description
 * Обработчик для невидимой Yandex Captcha.
 * 1. Находим блок капчи
 * 2. Если она уже верифицирована, то получаем токен и возвращаем его.
 * 3. Если нужна верификация, то делаем execute и возвращаем null (отправку формы нужно отменить).
 *    После того как верификация будет пройдена произойдёт вызов callback-функции для отправки формы.
 *
 * @param {DOMElement} form - форма
 * @param {function} callback - коллбек для повторной отправки формы
 * @returns {string|null} - токен или null
 */
export default (form, callback) => {
  if (!form || !callback || typeof callback !== 'function') {
    console.warn('В обработчик Yandex Captcha Invisible не была передана форма или коллбек', form, callback);

    return null;
  }

  if (!window.smartCaptcha) {
    console.warn('Yandex SmartCaptcha не загружена');

    return null;
  }

  try {
    // Находим блок Yandex Captcha в форме
    const yandexCaptchaBlock = form.querySelector('[data-yandex-captcha-type="invisible"]');

    if (!yandexCaptchaBlock) {
      console.warn('Невидимая Yandex Captcha не найдена в форме');

      return null;
    }

    // Проверяем, есть ли уже токен
    const tokenInput = yandexCaptchaBlock.querySelector('[name="yandex-smart-token"]');

    if (tokenInput && tokenInput.value) {
      // Токен уже есть, возвращаем его
      return tokenInput.value;
    }

    // Получаем ID виджета из data-атрибута
    const widgetId = yandexCaptchaBlock.dataset.yandexCaptchaWidgetId;

    if (!widgetId) {
      console.warn('ID виджета Yandex Captcha не найден');

      return null;
    }

    // Устанавливаем callback для контейнера
    yandexCaptchaBlock._yandexCaptchaExecuteCallback = function(token) {
      // Вызываем callback для повторной отправки формы
      callback(form, token);
    };

    if (isSafari()) {
      // Если Safari, то сбрасываем виджет перед выполнением, потому что Safari плохой браузер, где всё плохо работает
      window.smartCaptcha.reset(widgetId);
    }

    // Запускаем выполнение невидимой капчи
    window.smartCaptcha.execute(widgetId);

    // Возвращаем null, чтобы отменить текущую отправку формы
    return null;
  } catch (err) {
    console.error('Ошибка при выполнении Yandex Captcha Invisible:', err);

    return null;
  }
};
